<template>
  <div v-if="participantFlags.ENABLE_STOCK_DOWNLOAD == 1" class="text-center">
    <button
        v-if="(view === 'vehicle' && !vehicleLoading) ||
          (view === 'dashboard' && !dashboardLoading) ||
          (view === 'showcase' && !vehiclesCampaignLoading)"
        class="export-button mt-5 mb-5 text-center"
        @click="() => stockData()"
        :disabled="loadingExportStock"
    >
      <i v-if="!loadingExportStock" class="fa fa-download mr-1"></i>
      <i v-else class="fa fa-spinner fa-spin mr-1"></i>
      <span class="text-uppercase">
          {{ loadingExportStock ? 'Exportando...' : 'Estoque' }}
        </span>
    </button>
    <button v-else>
      <i class="fa fa-spinner fa-spin mr-1"></i>
    </button>
    <v-snackbar v-model="snackbar" location="top" :timeout="3000" color="error">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>
  
<script>
import { handleExportStock } from "@/helpers/exportStockHelper";
import { mapState } from "vuex";

export default {
    name: "StockExportButton",
    data: function () {
        return {
            loadingExportStock: false,
            snackbar: false,
            snackbarText: '',
        };
    },
    props: {
      enabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      view: {
        type: String,
        required: true
      }
    },
    computed: {
        ...mapState({
          participantFlags: (state) => state.participantFlags.flags,
          resultVehicleIds: (state) => state.filterForm.resultVehicleIds,
          vehicleLoading: (state) => state.filterForm.vehicleLoading,
          dashboardLoading: (state) => state.filterShowcase.dashboardLoading,
          resultDashboardVehicleIds: (state) => state.filterShowcase.resultDashboardVehicleIds,
          vehiclesCampaignLoading: (state) => state.filterShowcase.vehiclesCampaignLoading,
          resultCampaignVehicleIds: (state) => state.filterShowcase.resultCampaignVehicleIds
        })
    },
    emits: ["click"],
    methods: {
      getSelectedIds() {
        const idsMap = {
          vehicle: this.resultVehicleIds,
          dashboard: this.resultDashboardVehicleIds,
          showcase: this.resultCampaignVehicleIds
        };
        return idsMap[this.view] || [];
      },
      async stockData() {
        this.loadingExportStock = true;
        const result = await handleExportStock('Estoque.xlsx', this.getSelectedIds());
        if (!result.success) {
          this.snackbar = true;
          this.snackbarText = result.message;
        }
        this.loadingExportStock = false;
      },
    },
  };
</script>
  
<style scoped>
  .export-button {
  display: flex;
  width: 100%;
  padding: 10px 0;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.export-button:hover {
  opacity: 0.8;
  background-color: #E2E2E2;
}

.export-button span {
  color: #222;
  font-size: 14px;
  font-family: "Lexend Deca";
  font-weight: 700;
  margin-left: 4px;
}
</style>
  